<script setup lang="tsx">
import { getRuleStatusText } from '@/services/utils'

const model = defineModel({ default: 0 })
</script>

<template>
	<div class="d-inline-flex align-items-center text-nowrap">
		<i v-if="model == 0" class="bi bi-x-circle fs-4 text-danger"></i>
		<i v-else-if="model == 1" class="bi bi-check-circle fs-4 text-success"></i>
		<i v-else-if="model == 2" class="bi bi-x-circle fs-4 text-secondary"></i>
		<i v-else-if="model == 3" class="bi bi-exclamation-circle-fill fs-4 text-primary"></i>
		<i v-else-if="model == 4" class="bi bi-x-circle fs-4 text-secondary"></i>
		<i v-else-if="model == 5" class="bi bi-exclamation-circle-fill fs-4 text-success"></i>
		<span class="ms-2">{{ getRuleStatusText(model) }}</span>
	</div>
</template>
